import { render, staticRenderFns } from "./BattleCatonRoom.vue?vue&type=template&id=6794c827&scoped=true&"
import script from "./BattleCatonRoom.vue?vue&type=script&lang=js&"
export * from "./BattleCatonRoom.vue?vue&type=script&lang=js&"
import style0 from "./BattleCatonRoom.vue?vue&type=style&index=0&id=6794c827&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6794c827",
  null
  
)

export default component.exports